import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AppLayout from "../componets/AppLayout/AppLayout";
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import BackIcon from "../assets/SVGs/Info/BackIcon";
import { MembershipAPI } from "../api/membership";
import { membershipTabs } from "../componets/constant";
import Loader from "../componets/Loader";
import GeneralInfoTab from "../componets/MembershipTabs/GeneralInfoTab";
import MembershipPaymentsTab from "../componets/MembershipTabs/MembershipPaymentsTab";
import { GridCloseIcon, GridMoreVertIcon } from "@mui/x-data-grid";
import dayjs from "dayjs";
import MemeberWeeklyMeetsTab from "../componets/MembershipTabs/MemeberWeeklyMeetsTab";
import MemeberMeetUpTab from "../componets/MembershipTabs/MemeberMeetUpTab";
import ReferralTab from "../componets/MembershipTabs/ReferralTab";
import ClosedBusinessTab from "../componets/MembershipTabs/ClosedBusinessTabs";
import VisitorTab from "../componets/MembershipTabs/VisitorTab";
import PointsTab from "../componets/MembershipTabs/PointsTab";

const MembershipInfo = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [refetch, setRefetch] = useState(false);
  const [isLoading, setIsLoading] = useState(!refetch ? true : false);
  const [data, setData] = useState(null);
  const isMobileTable = useMediaQuery("(max-width:850px)");

  const [activeTab, setActiveTab] = useState(0);

  const [openAlert, setOpenAlert] = useState({
    open: false,
    info: "",
    color: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenReport = () => {
    localStorage.setItem("memberId", id);
    navigate(`/member-individual-report`);
  };

  const handleOpenExtendedReport = () => {
    localStorage.setItem("memberId", id);
    navigate(`/member-extended-report`);
  };
  useEffect(() => {
    const fetch = async () => {
      if (id) {
        try {
          const res = await MembershipAPI.getMember(id);
          setData(res);

          const expirationDays = dayjs(res?.membership_expiration_date).diff(
            dayjs(),
            "day",
          );

          if (res?.status) {
            // Membership is active
            if (expirationDays <= 0) {
              // Membership is expired
              setOpenAlert({
                open: true,
                info: "warning",
                bgcolor: "#FEF3C7",
                color: "#78350F", // Adjusted color for better visibility
                text: "The membership is expired.",
                day: expirationDays,
              });
            } else if (expirationDays <= 90) {
              // Membership is close to expiration
              setOpenAlert({
                open: true,
                info: "warning",
                bgcolor: "#FEF3C7",
                color: "#78350F",
                day: expirationDays,
              });
            } else {
              // Do not show any warning if expiration is more than 90 days
              setOpenAlert(null);
            }
          } else {
            // Membership is inactive
            setOpenAlert({
              open: true,
              info: "error",
              bgcolor: "#FFDCD6",
              color: "#631B18",
              text: "This member account is currently inactive.",
            });
          }
        } catch (e) {
          const status = e.response?.status;
          if (status === 401) {
            navigate("/login");
          }
        } finally {
          setIsLoading(false);
          setRefetch(false);
        }
      }
    };

    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, refetch]);

  return (
    <AppLayout>
      {isLoading ? (
        <Loader height="calc(100vh - 64px)" />
      ) : (
        <>
          <Box
            sx={{
              width: "100%",
              padding: isMobileTable ? "8px" : "24px 24px 12px",
              overflowX: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#fff",
                padding: isMobileTable ? "8px" : "24px 24px 12px",
                borderRadius: "8px",
                border: "1px solid #E2E8F0",
                height: "64px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <Link
                  to={`/membership`}
                  className="flex items-center justify-center back-hover"
                >
                  <BackIcon />
                </Link>

                <h5 className="grid-header">
                  {data?.first_name} {data?.last_name}
                </h5>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton
                  sx={{ border: "1px solid #AEBBCB" }}
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <GridMoreVertIcon />{" "}
                </IconButton>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={() => handleOpenReport()}>
                    Member Individual Report
                  </MenuItem>
                  <MenuItem onClick={() => handleOpenExtendedReport()}>
                    Member Individual Extended Report
                  </MenuItem>
                </Menu>
              </Box>
            </Box>

            <Box
              sx={{
                width: "100%",
                // padding: "0 24px",
                marginTop: "12px",
              }}
            >
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  backgroundColor: "#fff",
                  border: "1px solid #E2E8F0",
                  borderRadius: "8px",
                  padding: "8px",
                }}
                sm={{
                  padding: "24px",
                }}
              >
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    overflowX: "auto",

                    "&::-webkit-scrollbar": {
                      height: 1,
                    },
                  }}
                >
                  <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => {
                      setActiveTab(newValue);
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    aria-label="basic tabs example"
                    sx={{
                      minWidth: "max-content",

                      "& .MuiTabs-flexContainer": {
                        flexWrap: "nowrap",
                      },
                    }}
                  >
                    {membershipTabs.map((tab, index) => {
                      const IconComponent = tab.icon;

                      return (
                        <Tab
                          key={tab.label}
                          sx={{
                            minHeight: "40px",
                            fontSize: "16px",
                            lineHeight: "24px",
                            textTransform: "capitalize",
                            whiteSpace: "nowrap",
                          }}
                          label={tab.label}
                          icon={
                            <IconComponent
                              fill={activeTab === index ? "#0D2EED" : "#9E9E9E"}
                            />
                          }
                          iconPosition="start"
                        />
                      );
                    })}
                  </Tabs>
                </Box>

                <Box
                  sx={{
                    width: "720px",
                    padding: "24px 0 4px 0",
                    mb:
                      openAlert?.info === "error" || openAlert?.day <= 90
                        ? 2
                        : 0,
                  }}
                >
                  {(openAlert?.info === "error" || openAlert?.day <= 90) && (
                    <Collapse in={openAlert.open}>
                      <Alert
                        severity={openAlert?.info}
                        sx={{
                          backgroundColor: openAlert?.bgcolor,
                          borderRadius: "8px",
                          color: openAlert?.color,
                          fontWeight: "500",
                          padding: "2px 16px",
                        }}
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setOpenAlert(null);
                            }}
                          >
                            <GridCloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {openAlert?.text ? (
                          openAlert.text
                        ) : (
                          <>
                            The member account will expire in{" "}
                            <span style={{ color: "#0F172A" }}>
                              {openAlert?.day || ""}
                            </span>{" "}
                            days.
                          </>
                        )}
                      </Alert>
                    </Collapse>
                  )}
                </Box>

                {activeTab === 0 && (
                  <div className="tab-layout tab-layout-width">
                    <GeneralInfoTab data={data} setRefetch={setRefetch} />
                  </div>
                )}

                {activeTab === 1 && (
                  <div className="tab-layout gap-16">
                    <MembershipPaymentsTab id={data?.id} />
                  </div>
                )}

                {activeTab === 2 && (
                  <div className="tab-layout">
                    <MemeberWeeklyMeetsTab id={data?.id} />
                  </div>
                )}

                {activeTab === 3 && (
                  <div className="tab-layout">
                    <MemeberMeetUpTab id={data?.id} />
                  </div>
                )}
                {activeTab === 4 && (
                  <div className="tab-layout gap-16">
                    <ReferralTab id={data?.id} />
                  </div>
                )}
                {activeTab === 5 && (
                  <div className="tab-layout gap-16">
                    <ClosedBusinessTab id={data?.id} data={data} />
                  </div>
                )}

                {activeTab === 6 && (
                  <div className="tab-layout gap-16">
                    <VisitorTab id={data?.id} />
                  </div>
                )}
                {activeTab === 7 && (
                  <div className="tab-layout gap-16">
                    <PointsTab id={data?.id} />
                  </div>
                )}
              </Box>
            </Box>
          </Box>
        </>
      )}
    </AppLayout>
  );
};

export default MembershipInfo;
